// src/auth/types.ts

export interface IAuthUser {
  id: string;
  loginName: string;
  displayName: string;
  firstName?: string;
  lastName?: string;
  email: string;
  role: 'admin' | 'superadmin' | 'agent';
  customerIds: number[];
  locale: string;
}

export interface ILoginInput {
  username: string;
  password: string;
}

export interface ILoginResponse {
  accessToken: string;
  expiresIn: number;
  user: IAuthUser;
}

export interface IAuthState {
  isAuthenticated: boolean;
  isLoading: boolean;
  user: IAuthUser | null;
  accessToken: string | null;
  expiresAt: number | null;
  error: string | null;
}

export type AuthEvent =
  | 'onLoginSuccess'
  | 'onLoginError'
  | 'onLogout'
  | 'onTokenExpired'
  | 'onSessionRestored';

export interface IAuthContextType {
  state: IAuthState;
  login: (credentials: ILoginInput) => Promise<void>;
  loginWithProvider: (provider: 'AZURE' | 'GOOGLE', idToken: string) => Promise<void>;
  requestMagicLink: (email: string, redirectUrl?: string) => Promise<boolean>;
  loginWithMagicLink: (token: string) => Promise<void>;
  logout: () => void;
  isAuthenticated: boolean;
  user: IAuthUser | null;
  accessToken: string | null;
  customerIds: number[];
}

// Type aliases for backward compatibility
export type AuthUser = IAuthUser;
export type LoginInput = ILoginInput;
export type LoginResponse = ILoginResponse;
export type AuthState = IAuthState;
export type AuthContextType = IAuthContextType;

// Storage keys
export const AUTH_STORAGE_KEYS = {
  ACCESS_TOKEN: 'auth_access_token',
  USER: 'auth_user',
  EXPIRES_AT: 'auth_expires_at',
} as const;
